var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normap"},[(!_vm.tit)?_c('div',[_vm._v("/")]):_c('a-popover',{attrs:{"content":_vm.tit}},[_c('div',{staticClass:"norTie"},[_vm._v(_vm._s(_vm.tit))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }